var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { VendorService } from '@/services/vendor-service';
import { SupplierService } from '@/services/supplier-service';
import { ReferenceDataService } from '@/services/reference-data-service';
import { ValidationObserver, Validator } from 'vee-validate';
import ValidatedTextField from '@/components/shared/ValidatedTextField.vue';
import ValidatedTextarea from '@/components/shared/ValidatedTextarea.vue';
import ValidatedAutocomplete from '@/components/shared/ValidatedAutocomplete.vue';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
var Details = /** @class */ (function (_super) {
    __extends(Details, _super);
    function Details() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // validations
        _this.validationRules = {};
        _this.referenceDataLoaded = false;
        // options
        _this.options = {
            suppliers: [],
            vendorType: [],
            vendorContractTypes: [],
            vendorNonContractTypes: [],
            otherVendorTypes: [],
        };
        return _this;
    }
    Details.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isUniqueVendorId;
            var _this = this;
            return __generator(this, function (_a) {
                this.validationRules = this.vendorService.getValidationRules();
                this.referenceDataLoaded = false;
                if (this.isExistingVendor === false) {
                    isUniqueVendorId = function (value) {
                        return _this.vendorService.doesVendorIdExist(_this.item)
                            .then(function (response) {
                            return {
                                valid: response === false,
                                data: {
                                    message: 'Vendor ID is already in use',
                                },
                            };
                        });
                    };
                    Validator.extend('isUniqueVendorId', {
                        validate: isUniqueVendorId,
                        getMessage: function (field, params, data) { return data.message; },
                    }, {
                        initial: false,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    Details.prototype.getReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var suppliersResponse, referenceDataResponse, otherTypes, otherModules, otherTypesResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if we have already loaded the reference data, don't load again
                        if (this.referenceDataLoaded) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.supplierService.getAllRef()];
                    case 1:
                        suppliersResponse = _a.sent();
                        this.options.suppliers = suppliersResponse.success
                            ? suppliersResponse.data
                            : [];
                        return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: [
                                    'VENDOR_TYPES',
                                    'VENDOR_CONTRACT_TYPES',
                                    'VENDOR_NON_CONTRACT_TYPES',
                                ], includeDeleted: false })];
                    case 2:
                        referenceDataResponse = _a.sent();
                        if (!referenceDataResponse.success) return [3 /*break*/, 4];
                        // vendor types
                        this.options.vendorType = referenceDataResponse.data.filter(function (item) { return item.module === 'VENDOR_TYPES'; });
                        // vendor contract types
                        this.options.vendorContractTypes = referenceDataResponse.data.filter(function (item) { return item.module === 'VENDOR_CONTRACT_TYPES'; });
                        // vendor non-contract types
                        this.options.vendorNonContractTypes = referenceDataResponse.data.filter(function (item) { return item.module === 'VENDOR_NON_CONTRACT_TYPES'; });
                        otherTypes = referenceDataResponse.data.filter(function (item) { return item.module === 'VENDOR_TYPES' && item.code !== 'C' && item.code !== 'NC'; });
                        otherModules = otherTypes.map(function (item) { return 'VENDOR_' + item.code + '_TYPES'; });
                        return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: otherModules, includeDeleted: false })];
                    case 3:
                        otherTypesResponse = _a.sent();
                        this.options.otherVendorTypes = otherTypesResponse.success ? otherTypesResponse.data : [];
                        return [3 /*break*/, 5];
                    case 4:
                        this.options.vendorType = [];
                        this.options.vendorContractTypes = [];
                        this.options.vendorNonContractTypes = [];
                        this.options.otherVendorTypes = [];
                        _a.label = 5;
                    case 5:
                        this.referenceDataLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Details.prototype, "vendorSubTypes", {
        get: function () {
            var vendorType = this.item.vendorType;
            switch (vendorType) {
                case 'C':
                    return this.options.vendorContractTypes;
                case 'NC':
                    return this.options.vendorNonContractTypes;
                default:
                    return this.options.otherVendorTypes.filter(function (item) { return item.module === 'VENDOR_' + vendorType + '_TYPES'; });
            }
        },
        enumerable: false,
        configurable: true
    });
    // Clear vendor sub type when vendor type changes
    Details.prototype.onVendorTypeChanged = function (newValue, oldValue) {
        if (oldValue && newValue && oldValue !== newValue) {
            var vendor = __assign({}, this.item);
            vendor.vendorSubType = '';
            this.item = vendor;
        }
    };
    Details.prototype.getValidationRulesByField = function (field) {
        var rules = __assign({}, this.vendorService.getValidationRules());
        // disable the unique supplier id validation
        if (this.isExistingVendor) {
            // tslint:disable-next-line:no-string-literal
            rules[field]['isUniqueVendorId'] = false;
        }
        else {
            // tslint:disable-next-line:no-string-literal
            rules[field]['isUniqueVendorId'] = true;
        }
        return rules[field];
    };
    Object.defineProperty(Details.prototype, "isExistingVendor", {
        get: function () {
            return (this.$route.params &&
                this.$route.params.id &&
                this.$route.params.id !== '0');
        },
        enumerable: false,
        configurable: true
    });
    Details.prototype.onStepChanged = function (val, oldVal) {
        if (val && val !== oldVal && val === 'D') {
            this.getReferenceData();
        }
    };
    var _a, _b, _c;
    __decorate([
        lazyInject(TYPES.VendorService),
        __metadata("design:type", typeof (_a = typeof VendorService !== "undefined" && VendorService) === "function" ? _a : Object)
    ], Details.prototype, "vendorService", void 0);
    __decorate([
        lazyInject(TYPES.SupplierService),
        __metadata("design:type", typeof (_b = typeof SupplierService !== "undefined" && SupplierService) === "function" ? _b : Object)
    ], Details.prototype, "supplierService", void 0);
    __decorate([
        lazyInject(TYPES.ReferenceDataService),
        __metadata("design:type", typeof (_c = typeof ReferenceDataService !== "undefined" && ReferenceDataService) === "function" ? _c : Object)
    ], Details.prototype, "referenceDataService", void 0);
    __decorate([
        Watch('item.vendorType', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Details.prototype, "onVendorTypeChanged", null);
    __decorate([
        Watch('step', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Details.prototype, "onStepChanged", null);
    Details = __decorate([
        Component({
            components: {
                'validation-observer': ValidationObserver,
                'validated-text-field': ValidatedTextField,
                'validated-text-area': ValidatedTextarea,
                'validated-autocomplete': ValidatedAutocomplete,
            },
        })
    ], Details);
    return Details;
}(Mixins(SteppedPageMixin)));
export default Details;
